<div class="text-right w-100pc">
  <span class="preapproval-badge d-inline-block mt-2">
      {{'distance_to_empty' | translate}}
      ({{model.mileage && model.mileage.mileageUOM == mileageUOMEnum.Kilometre ? "km" : "m"}})
      {{model.mileage && model.mileage.nrAvailableDistance}}
  </span>
</div>
